import { TrlPillQuantity } from './TrlPillQuantity';

export { TrlPillQuantity } from './TrlPillQuantity';
export default TrlPillQuantity;
